import React, { useState } from 'react';

const Quickbook = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [testMode, setTestMode] = useState(false);
  const [clientId, setClientId] = useState('');
  const [clientSecret, setClientSecret] = useState('');

  const toggle = () => {
    setIsExpanded(!isExpanded); // Toggle the state
  };

  const toggleTestMode = () => {
    setTestMode(!testMode);
  };

  const handleSave = () => {
    // Simulate saving the data
    console.log('Saved Client ID:', clientId);
    console.log('Saved Client Secret:', clientSecret);
    console.log('Test Mode:', testMode);

    // Reset all fields after saving
    setClientId('');
    setClientSecret('');
    setTestMode(false);
   
  };

  return (
    <div className="mx-auto mt-8  xl:px-72">
      <div className="flex items-left space-x-36">
        <span className="text-gray-700 font-bold text-xl ">QuickBooks</span>
        {/* Toggle button for QuickBooks enable/disable */}
        <button
          onClick={toggle}
          className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-left  justify-left text-sm ${isExpanded ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'}`}
        >
          <div
            className={`w-6 h-6 bg-white rounded-full absolute top transition-all ${isExpanded ? 'right-0.5' : 'left-0.5'}`}
          />
        </button>
      </div>

      <div
        className={`overflow-hidden transition-all mt-10 duration-1000 ease-in-out`}
        style={{
          height: isExpanded ? 'auto' : '0', // Control height for smooth transition
          opacity: isExpanded ? '1' : '0', // Fade in/out
          paddingTop: isExpanded ? '10px' : '0', // Adjust padding to smooth transition
          paddingBottom: isExpanded ? '10px' : '0', // Adjust padding to smooth transition
        }}
      >
        {isExpanded && (
          <div>
            <div>
              <label htmlFor="clientId" className="block text-gray-700 font-medium">
                QuickBooks Client ID
              </label>
              <input
                id="clientId"
                type="text"
                value={clientId}
                onChange={(e) => setClientId(e.target.value)} // Handle input change
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className='mt-6'> 
              <label htmlFor="clientSecret" className="block text-gray-700 font-medium">
                QuickBooks Client Secret
              </label>
              <input
                id="clientSecret"
                type="text"
                value={clientSecret}
                onChange={(e) => setClientSecret(e.target.value)} // Handle input change
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {/* Test Mode Toggle */}
            <div className="flex flex-row mt-5">
              <label htmlFor="testMode" className="block text-gray-700 pr-5 font-medium">
                Test Mode
              </label>
              <button
                onClick={toggleTestMode}
                className={`relative w-12 h-6 rounded-full transition-all duration-500 flex items-center justify-center text-sm ${testMode ? 'bg-green-500 text-white' : 'bg-gray-300 text-gray-600'}`}
              >
                <div
                  className={`w-6 h-6 bg-white rounded-full absolute top transition-all ${testMode ? 'right-0.5' : 'left-0.5'}`}
                />
              </button>
            </div>

            {/* Save Button */}
            <div className="mt-4">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition"
              >
                Save
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Quickbook;
